import { MIX_PANEL_PERSISTENCE_NAME } from "../../lib/mixpanel/mixpanel.config";

export function localStorageSelectiveClean(): void {
  const protectedKeys: string[] = [MIX_PANEL_PERSISTENCE_NAME, "__mpq_"];
  const allKeys = Object.keys(localStorage);
  const keysToRemove = allKeys.filter(function isNotProtected(key) {
    return !protectedKeys.some(function containsProtectedKey(protectedKey) {
      return key.includes(protectedKey);
    });
  });

  keysToRemove.forEach(function removeKey(key) {
    console.debug("Removing localStorage key:", key);
    localStorage.removeItem(key);
  });
}
